<div *ngIf="data$ | async as data" class="faq">
  <div class="faq__content">
    <tui-accordion-item *ngFor="let faq of data.faq">
      <div class="question-wrapper" [textContent]="faq.question"></div>

      <ng-template tuiAccordionItemContent>
        <div class="answer-wrapper" [textContent]="faq.answer"></div>
      </ng-template>
    </tui-accordion-item>
  </div>

  <div class="text_size-m" [textContent]="data.footer"></div>
</div>
